var map = {
	"./materialSymbols.en": [
		20341,
		777
	],
	"./materialSymbols.en.ts": [
		20341,
		777
	],
	"./materialSymbols.pl": [
		51206,
		260
	],
	"./materialSymbols.pl.ts": [
		51206,
		260
	],
	"./materialSymbols.ru": [
		48075,
		915
	],
	"./materialSymbols.ru.ts": [
		48075,
		915
	],
	"./materialSymbols.ts": [
		67334
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 44870;
module.exports = webpackAsyncContext;